import { Box, CardContent, styled } from '@mui/material';

export const BoxStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '2rem',
  alignSelf: 'center',
}));

export const BoxButtonStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '1.5rem',
  flexDirection: 'row',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const SentTokenStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  maxWidth: '40rem',
  padding: '0.5rem 1.5rem 2rem 1.5rem',
  margin: '0 auto',

  [theme.breakpoints.up('md')]: {
    padding: '0.5rem 0 2.5rem 0',
  },
}));

export const InputAndButtonValidationStyled = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
}));

export const PaddingButton = styled(Box)(() => ({
  marginBottom: '1rem',
}));

export const ButtonGroup = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '1rem',
}));

export const CardContentStyled = styled(CardContent)(() => ({
  padding: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const AlignButton = styled('div')(() => ({
  width: '100%',
  maxWidth: '18.5rem',
  paddingBottom: '1rem',
}));
